/**
 * @generated SignedSource<<8a8d806ea73f27056b644a09e8af3fb4>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* eslint-disable */

'use strict';

var node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ContributionsDatavizListThemeContribution_theme",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "slug",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ContributionCardThemes_theme"
    }
  ],
  "type": "Theme",
  "abstractKey": null
};

node.hash = "5576c76e4f703cf54881508e806b9472";

module.exports = node;
